<!--Loading Spinner  IsLoadingTask -->
<section *ngIf="IsLoadingTask">
  <app-loader></app-loader>
</section>
<!--Loading Spinner  -->
<main id="main-app-container" class="main-container" appReloadEvent>
  <customHeader *ngIf="showToggle"></customHeader>
  <app-toggle-switch *ngIf="tempShow" [showToggle]="false"></app-toggle-switch>

  <router-outlet></router-outlet>
  <custom-popup [config]="Config" [title]="''" [showClose]="false" [subtitle]="''" [id]="'sessionExpired'"
    class="session-expired">
    <!-- <div class="modal-body height-medium">
      <div class="clearfix">
        <h5 class="text-center text-danger">Your session has been expired.
          <br/>Please try with another session.</h5>
        <div class="form-group btn-center btn-align-lt top-spc-20 no-bottom">
          <button (click)="proceed('INSINSURANCE', 'HOME');" type="button" class="btn btnconfirm" type="button">
            OK
          </button>
        </div>
      </div>
    </div> -->
    <div class="modal-header">
      <a class="close-btn" href="javascript:void(0)" (click)="closeSessionPopup();">
        <i class="close-desktop hide-mobile" aria-label="Close">
          <ng-container *ngTemplateOutlet="closeIcon"></ng-container>
        </i>
        <div class="center close-mobile hide-desktop">
          <div class="line view-more-popup hide-desktop"></div>
        </div>
      </a>
    </div>
    <div class="modal-body timeout-popup-body">
      <div class="timeout-image">
        <img src="assets/img/svg/session-timeout-1.svg" *ngIf="!sessionExpired" [ngClass]="{'fade-out':sessionExpired}"
          width="100px" height="100px">
        <img src="assets/img/svg/session-timeout-2.svg" *ngIf="sessionExpired" [ngClass]="{'fade-in':sessionExpired}"
          width="100px" height="100px">
      </div>
      <div class="timeout-section" *ngIf="!sessionExpired" [ngClass]="{'fade-out':sessionExpired}">
        <h4 class="title text-center">
          Your online session will expire in
        </h4>
        <div class="timer">
          <div class="timer-progress">
            <span class="timer-title">{{counting}}</span>
            <div class="mask"></div>
            <div class="left"></div>
            <div class="right"></div>
          </div>
        </div>
        <div class="content">
          <div class="timer-disclaimer text-center">
            <h5>Please click "<b>Continue</b>" to keep working;</h5>
            <h5>Or click "<b>Cancel</b>" to end your session now.</h5>
          </div>
        </div>
      </div>
      <div class="timeout-section" *ngIf="sessionExpired" [ngClass]="{'fade-in':sessionExpired}">
        <h4 class="title text-center">
          Your session has expired
        </h4>
        <div class="content">
          <div class="timer-disclaimer text-center">
            <h5>Don't worry, we kept all your data in place.</h5>
            <h5>You will be redirected to the Home page,</h5>
            <h5>Click Ok to contine.</h5>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <div class="timer-action" *ngIf="!sessionExpired" [ngClass]="{'fade-out':sessionExpired}">
        <button class="btn btn-primary btnconfirm" (click)="extendSession()">CONTINUE</button>
        <a href="javascript:void(0)" class="logoff pointer-hover" (click)="redirectToLandingPage()">CANCEL</a>
      </div>
      <div class="timer-action" *ngIf="sessionExpired" [ngClass]="{'fade-in':sessionExpired}">
        <button class="btn btn-primary btnconfirm" (click)="redirectToLandingPage()">OK</button>
      </div>
    </div>
  </custom-popup>
</main>
<ng-template #closeIcon>
  <svg id="Group_18511" data-name="Group 18511" xmlns="http://www.w3.org/2000/svg" width="23.808" height="23.808"
    viewBox="0 0 23.808 23.808">
    <defs>
      <style>
        .cls-1 {
          fill: rgb(255, 242, 234);
        }

        .cls-2 {
          fill: none;
          stroke: rgb(255, 105, 5);
          stroke-linecap: round;
        }
      </style>
    </defs>
    <rect id="Rectangle_2196" data-name="Rectangle 2196" class="cls-1" width="23.808" height="23.808" rx="11.904" />
    <g id="Group_18510" data-name="Group 18510" transform="translate(7.383 7.614)">
      <line id="Line_1047" data-name="Line 1047" class="cls-2" x2="9.416" y2="9.416"
        transform="translate(0.081 0.085)" />
      <line id="Line_1048" data-name="Line 1048" class="cls-2" x2="9.416" y2="9.416"
        transform="matrix(0.017, 1, -1, 0.017, 9.415, 0)" />
    </g>
  </svg>
</ng-template>